import ProductsList from "./ProductsList";
// import Banner1 from "./Banner1";
import BeforeAfter from "./BeforeAfter";
import Services from "./Services";
import Testemonials from "./Testemonials";

import Blog from "./Blog";
import BannerSlider from "../components/BannerSlider";
import OfferSlider from "../components/OfferSlider";
// import PolicyStrip from "./PolicyStrip";

import { useEffect } from "react";

export default function Home({
  bannerImages,
  homeRef,
  productsList,
  viewProduct,
  productsRef,
  addItemtoCart,
  removeItemtoCart,
  cartList,
  addItemtoWishlist,
  removeItemtoWishlist,
  wishList,
  bundlesRef,
  banner50Images,
  testimonialsList,
  blogsList,
  blogsRef,
  viewBlog,
}) {
  useEffect(() => {
    if (window.location.hash) {
      const hash = window.location.hash;

      // Ignore invalid hashes like "#!" or just "#"
      if (hash !== "#!" && hash !== "#") {
        const el = document.querySelector(hash);
        if (el) {
          setTimeout(() => {
            el.scrollIntoView({ behavior: "smooth" });
            window.history.replaceState(null, "", window.location.pathname);
          }, 200);
        }
      }
    }
  }, []);

  return (
    <>
      {/* Slider */}

      <BannerSlider bannerImages={bannerImages} homeRef={homeRef} />

      {/* Deal of the Day */}
      <ProductsList
        productsList={productsList}
        viewProduct={viewProduct}
        productsRef={productsRef}
        addItemtoCart={addItemtoCart}
        removeItemtoCart={removeItemtoCart}
        cartList={cartList}
        addItemtoWishlist={addItemtoWishlist}
        removeItemtoWishlist={removeItemtoWishlist}
        wishList={wishList}
      />

      {/* OfferSlider */}
      <OfferSlider bundlesRef={bundlesRef} banner50Images={banner50Images} />

      {/* Banner 1 */}
      {/* <Banner1 /> */}

      {/* BeforeAfter  */}
      <BeforeAfter />

      {/* Services */}
      <Services />
      <br />
      <br />
      {/* Testimonials */}
      <Testemonials testimonialsList={testimonialsList} />
      <br />
      <br />
      <Blog
        blogsList={blogsList}
        blogsRef={blogsRef}
        viewBlog={viewBlog}
        id="blogs"
      />
      <br />
      {/* <PolicyStrip />  no need we have our own*/}
    </>
  );
}
